'use client';

import React from 'react';
import { useParallax } from 'react-scroll-parallax';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { SxProps } from '@mui/system/styleFunctionSx';
import { mergeSx } from '@jucy-ui/appearance';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { SiteContainer } from '@/components/SiteContainer';
import { useResolveBlockHeight } from '@/hooks/useResolveBlockHeight';
import { useSiteLinkPrefix } from '@/hooks/useSiteLinkPrefix';
import { focusPointBgStyles } from '@/lib/focusPointBgStyles';
import { CmsBannerBlock } from '@/services/cms/blocks/CmsBannerBlock';


export interface BannerBlockProps extends CmsBannerBlock {
    sx?: SxProps<Theme>;
}

export const BannerBlock = ({ sx, ...props }: BannerBlockProps) => {
    const hasLink = Boolean(props.callToActionLink?.link);
    const addSiteLinkPrefix = useSiteLinkPrefix();
    const href = props.callToActionLink?.link ? addSiteLinkPrefix(props.callToActionLink.link) : undefined;
    const extraProps = hasLink ? { component: Link, href, target: props.callToActionLink?.target || undefined, underline: 'none' } : {};
    const height = useResolveBlockHeight(props.height);
    const { ref } = useParallax<HTMLDivElement>({
        translateY: ['-80px', '80px'],
    });
    return (
        <BlockContainer sx={sx} {...props}>
            <Box
                {...extraProps}
                sx={mergeSx({
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    height: height,
                    ...focusPointBgStyles(props.file),
                })}
            >
                <SiteContainer ref={ref}>
                    <BlockTitle sx={{ color: 'white', textShadow: '0 0 0.5rem rgba(0,0,0,.85)', mb: 0 }} {...props} />
                </SiteContainer>
            </Box>
        </BlockContainer>
    );
};
